<template>
  <div class="min-h-screen flex items-center justify-center px-4 bg-white">
    <div class="max-w-md">
      <p class="text-2xl md:text-3xl font-light leading-normal">
        {{ $t('message.error') }}
      </p>
    </div>
  </div>
</template>
